import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cart-verify-popup',
  templateUrl: './cart-verify-popup.component.html',
  styleUrls: ['./cart-verify-popup.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf]
})
export class CartVerifyPopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { messages: string[], totalItems: number, isFreight?: boolean , proccedToCheckout: boolean},
    public dialogRef: MatDialogRef<CartVerifyPopupComponent>,
    private router: Router
  ) { }

  redirectToCart(): void {
    this.dialogRef.close();
    const currentUrl = this.router.url;
    if (currentUrl == '/cart') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/cart']);
    });
    }
    else{
     this.router.navigate(['/cart']);
    }
  }

  redirectToCheckout():void{
    this.dialogRef.close();
    const currentUrl = this.router.url;
    if (currentUrl == '/checkout' && !this.data.proccedToCheckout) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/checkout']);
    });
    }
    else{
     this.router.navigate(['/checkout']);
    }
  }
}